import { render, staticRenderFns } from "./BasicEduTeacherLeader.vue?vue&type=template&id=4005ecba"
import script from "./BasicEduTeacherLeader.vue?vue&type=script&lang=js"
export * from "./BasicEduTeacherLeader.vue?vue&type=script&lang=js"
import style0 from "./BasicEduTeacherLeader.vue?vue&type=style&index=0&id=4005ecba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports